<template>
  <div>
    <el-table :row-key="getRowKeys"  :data="table" :expand-row-keys="expands" @expand-change="change" style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-button type="primary" @click.native="addChannel(props.row.index)" >添加通道</el-button>
          <el-button type="primary" @click.native="delChannel(props.row.index)" >删除</el-button>
          <span class="red">Tips:通道状态或者关联状态为停用时，该通道配置将不生效</span>
          <el-table :row-class-name="tableRowClassName" row-key="ID" ref="groupTable" v-if="sortPath" :data="props.row.table" class="pathTable"  @selection-change="changeFun" style="width: 100%">
            <el-table-column
              type="selection"
              @selection-change="changeFun"
              width="55">
            </el-table-column>
            <el-table-column
              label="优先级"
              width="80"
              prop="groupIndex"
              >
            </el-table-column>
            <el-table-column
              label="通道名称"
              :show-overflow-tooltip="tooltip"
              width="420"
              prop="pipeName">
            </el-table-column>
            <el-table-column
              label=""
              width=""
              >
              <template slot-scope="scope">
                <el-button size="mini" v-clipboard:success="onCopy" v-clipboard:error="onError" v-clipboard:copy="scope.row.pipeName"  >复制</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="连接超时时间(ms)"
              :show-overflow-tooltip="tooltip"
              prop="conTimeout">
            </el-table-column>
            <el-table-column
              label="读取超时时间(ms)"
              :show-overflow-tooltip="tooltip"
              prop="soTimeout">
            </el-table-column>
            <el-table-column
              label="关联状态"
              >
              <template slot-scope="scope">
                <span >{{ scope.row.active === 1 ? '启用' : '停用' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="通道状态"
              >
              <template slot-scope="scope">
                <span  :class="scope.row.pipeState === 1? '': 'red'">{{ scope.row.pipeState === 1 ? '启用' : '停用' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="权重"
              >
              <template slot-scope="scope">
                <span >{{ scope.row.ratio ? scope.row.ratio : 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="通道类型"
              >
              <template slot-scope="scope">
                <span >{{ scope.row.pipeType === 1 ? '前置' : '默认' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini"  @click.native="editChannel(scope, props.row.index)" >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" @click.native="saveGroup(props.row.index, props.row)">保存</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="通道组名称"
        :show-overflow-tooltip="tooltip"
        width="100"
        prop="groupName">
      </el-table-column>
      <el-table-column
        label="通道组状态"
        :show-overflow-tooltip="tooltip"
        width="100"
        >
        <template slot-scope="scope">
          <span >{{ scope.row.status === 1 ? '启用' : '禁用' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="关联通道"
        :show-overflow-tooltip="tooltip"
        width="300"
        >
        <template slot-scope="scope">
          <span >{{ scope.row.pipes.join(',') }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="是否缓存"
        :show-overflow-tooltip="tooltip"
        width="100"
        >
        <template slot-scope="scope">
          <span >{{ scope.row.cached === true ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        :show-overflow-tooltip="tooltip"
        prop="createTime">
      </el-table-column>
      <el-table-column
        label="操作人"
        :show-overflow-tooltip="tooltip"
        prop="creator">
      </el-table-column>
      <el-table-column
        label="通道组描述"
        :show-overflow-tooltip="tooltip"
        prop="groupDesc">
      </el-table-column>
      <el-table-column
         width="260"
        label="操作"
        >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click.native="editGroup(scope)"
            >编辑
          </el-button>
          <el-button
            size="mini"
            @click.native="delGroup(scope)"
            >删除
          </el-button>
          <el-button
            :disabled="(scope.row.groupName === 'default')"
            @click.native="reletedCusGroup(scope)"
            size="mini"
            >已关联客户
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<style>
.el-table .warning-row {
  background: rgba(0,0,0,0.4) !important;
}
.el-table--enable-row-hover .el-table__body .warning-row:hover>td{
  background: rgba(0,0,0,0.1) !important;
}
.red {
  color: red;
}
</style>
<script>
import Sortable from 'sortablejs'
export default {
  props: ['pathTable', 'pipeIdList', 'prodId'],
  data () {
    return {
      tooltip: true,
      index: '', // 点击table某一行的下标
      expands: [],
      red: 'red',
      delete: [],
      sortPath: true, // 防止拖拽排序出现数据和视图不一致问题
      // table: this.pathTable,
      deleteSave: [], // 关联通道组删除的数据
      getRowKeys (row) {
        return row.index
      }
    }
  },
  computed: {
    table () {
      return this.$store.state.editPromain.table
    },
    ifDrop () {
      return this.$store.state.editPromain.ifDrop
    }
  },
  mounted () {
    this.$root.eventHub.$on('clear', (op) => {
      this.expands = [] // 关闭展开行
    })
  },
  watch: {
    ifDrop (val) {
      this.rowDrop() // 关联通道渲染后增加排序监听
      if (val) {
        // this.rowDrop() // 关联通道渲染后增加排序监听
        this.$store.commit('editPromain/ifDrop', false) // 防止再次打开时不会添加排序
      }
    }
  },
  methods: {
    httpGroup () {
      console.log('ss')
    },
    change (row, expandedRows) { // 展开行函数
      console.log(expandedRows)
      this.$emit('httpGroup', row)
      let _this = this
      if (expandedRows.length) { // 展开发送信息给父组件
        this.expands = []
        this.deleteSave = [] // 清空之前删除数据
        if (row) {
          this.expands.push(row.index)
          this.index = Number(row.index)
        }
        this.$store.commit('editPromain/changeIndex', this.index)
        console.log(this.index)
        // this.$emit('httpChannel', row)
        this.$store.dispatch('editPromain/httpChannel', row).then(() => {
          _this.$nextTick(() => {
            _this.rowDrop()
          })
        })
      } else {
        this.expands = []
      }
    },
    tableRowClassName (row, rowIndex) {
      if (row.row.active === 0) {
        return 'warning-row'
      }
      return ''
    },
    onCopy () {
      this.$message.success('复制成功')
    },
    onError () {
      this.$message.error('复制失败')
    },
    rowDrop () { // table拖拽排序
      const tbody = document.querySelector('.pathTable tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd (op) {
          let index = _this.index
          console.log(_this.index)
          if (index === '') return
          op.index = index
          _this.sortPath = false
          _this.$store.commit('editPromain/sort', op) // 排序
          // _this.sortPath = true
          _this.$nextTick(function () {
            _this.sortPath = true
            _this.$nextTick(function () {
              // 重新渲染之后，重新进行Sortable绑定
              this.rowDrop() // 关联通道渲染后增加排序监听
            })
          })
        }
      })
    },
    changeFun (val) {
      this.delete = val
    },
    editGroup (op) {
      this.$emit('editGroup', op)
    },
    delGroup (op) {
      this.$emit('delGroup', op)
    },
    reletedCusGroup (op) {
      this.$emit('reletedCusGroup', op)
    },
    saveGroup (index, row) {
      let op = {}
      let total = 0
      op.prodId = this.prodId
      op.groupId = row.groupId
      op.deleteRefs = []
      op.updateRefs = []
      op.newRefs = []
      op.deleteRefs = this.deleteSave
      if (!this.table[index].table.length && !this.deleteSave.length) {
        this.$message.error('请先关联通道')
        return
      }
      for (let i = 0; i < this.table[index].table.length; i++) {
        total += Number(this.table[index].table[i].ratio)
        if (this.table[index].table[i].pipeType === 0) {
          if (this.table[index].table[i + 1] && this.table[index].table[i + 1].pipeType && this.table[index].table[i + 1].pipeType === 1) {
            this.$message.error('前置通道必须在默认通道之前')
            return
          }
        }
        this.table[index].table[i].useOrder = this.table[index].table[i].groupIndex // 替换排序
        if (this.table[index].table[i].prodPipeRefId) {
          op.updateRefs.push(this.table[index].table[i]) // 更新
        } else {
          op.newRefs.push(this.table[index].table[i]) // 新增
        }
      }
      if (total !== 100 && total !== 0) {
        this.$message.error('通道权重必须为100% 和 0!')
        return
      }
      this.$axios({
        url: this.$API.product.updatePipeListByGroup,
        method: 'post',
        data: op
      }).then((response) => {
        this.$store.commit('editPromain/changeIndex', this.index)
        this.$store.dispatch('editPromain/httpChannel', row) // 重新刷新数据
        this.deleteSave = [] // 清空删除数据
        this.$message.success('通道关联成功')
      }).catch((err) => {
        console.log(err)
      })
    },
    delChannel (index) {
      // this.$emit('delChannel', index)
      if (!this.delete.length) {
        this.$message.error('请选择关联通道!')
        return
      }
      for (let i = 0; i < this.table[index].table.length; i++) {
        for (let item of this.delete) {
          if (this.table[index].table[i].pipeId === item.pipeId) {
            if (item.prodPipeRefId) {
              this.deleteSave.push(item.prodPipeRefId)
            }
            this.table[index].table.splice(i, 1)
            i--
            break
          }
        }
      }
      let op = {}
      op.index = index
      op.delete = this.delete
      this.$emit('delChannel', op)
      console.log(this.table[index].table)
      this.table[index].table.forEach((v, i) => {
        v.groupIndex = i + 1 // 增加排序的优先级
        v = Object.assign({}, v)
      })
      let oldArr = this.table[index].table
      let newArr = oldArr.slice(0) // 克隆数组
      // this.table[index].table = newArr // 整体重新赋值
      this.$set(this.table[index], 'table', newArr)
      this.$refs['groupTable'].clearSelection() // 清空用户选择状态
    },
    addChannel (index) {
      this.$emit('addChannel', index)
    },
    editChannel (val, index) {
      val.index = index
      this.$emit('editChannel', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/proManage/path/Path.vue